// extracted by mini-css-extract-plugin
module.exports = {"error-container":"error_error-container__2jhdE","icon":"error_icon__3FwrE","error-text":"error_error-text__2sGBC"};